/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class medicationactivity extends IceEntity {
	medication_activity_key: string = ""; // prim key for activity and order
  system_entry_date: any = NaN;
  immunization_type: number = 0;
  pharmacy_order_type: string = "";
  pharmacy_key: string = "";
  medical_service_key: string = "";
  days_supply = 0;
  medication_key: string = "";
  offline_record_status = 0;

  // Activity
  activity_type = 0;
  activity_date = NaN;
  activity_description: string = "";

  administered_code: string = "";
  administered_code_productcodequalifier: string = "";
  administered_amount = 0.0;
  administered_amount_codelistqualifier: string = "";
  administered_units: string = "";
  sig: string = "";
  route_code: string = "";
  substance_lot_number: string = "";
  drugcoveragestatuscode: string = "";
  substance_expiration_date = NaN;
  site: string = "";

  // Order Entry
  order_entry_key: string = "";
  order_entry_date: any = NaN;
  order_status_note: string = "";
  order_entry_group_key: string = "";
  signature: string = "";
  signature_date: any = NaN;
  manufacturer_product_key: string = "";
  order_status_type: number = 0;
  order_note: string = "";
  substitution_not_allowed: boolean = false;
  rx_quantity: number = 0;
  rx_quantity_qualifier: string = "";
  message_key: string = "";
  agent_first_name: string = "";
  agent_last_name: string = "";
  agent_ctp_number: string = "";
  rx_header_relatestomessageid: string = "";
  rx_header_rxreferencenumber: string = "";
  rx_request_returnreceipt: string = "";
  rx_request_requestreferencenumber: string = "";
  rx_response_type: string = "";
  rx_response_referencenumber: string = "";
  rx_response_note: string = "";
  rx_response_reason: string = "";
  pid3_patient_first_name: string = "";
  pid3_patient_last_name: string = "";
  pid3_patient_initial: string = "";
  pid7_patient_dob: any = NaN;
  pid11_patient_street1: string = "";
  pid11_patient_street2: string = "";
  pid11_patient_city: string = "";
  pid11_patient_state: string = "";
  pid11_patient_postal_code: string = "";
  pid13_patient_phone: string = "";
  orc24_ordering_provider_street1: string = "";
  orc24_ordering_provider_street2: string = "";
  orc24_ordering_provider_city: string = "";
  orc24_ordering_provider_state: string = "";
  orc24_ordering_provider_postal_code: string = "";
  orc24_ordering_provider_npi: string = "";
  orc23_ordering_facility_phone: string = "";
  message_request_code: string = "";

  // Referral
  trans_account: string = "";
  requester_trans_account: string = "";
  requester_account_type: IceTypes.ACCOUNT_TYPE = 0;
  subscriber_key: string = "";
  coverage_key: string = "";
  benefit_information_key: string = "";

  administered_units_text: string = "";

	request_category_code: string = "";

  gettablename(): string {
    return "MEDICATION_ACTIVITY";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "OBSERVS") return true;
    else if (ColumnName == "ALERTS") return true;
    else if (ColumnName == "PROCSRS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "OBSERVS") return "OBSERVATION";
    else if (ColumnName == "ALERTS") return "ALERT";
    else if (ColumnName == "PROCSRS") return "PROCEDURE";

    return null;
  }
}
